import type { NoveltyEvaluationResponse } from '@/types/material/novelty-check';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

@injectable()
export class MaterialNoveltyApiImpl extends PsHttpService implements MaterialNoveltyApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/material/novelty-check`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getEvaluationData(agent_job_id: string, doc_id: string) {
        return this.post<PatSnapCommonResponseData<NoveltyEvaluationResponse>>({
            url: '/get-data',
            data: {
                agent_job_id,
                doc_id,
            },
        }).then(res => {
            return res.data as NoveltyEvaluationResponse
        })
    }
}

export const MaterialNoveltyApi = Symbol('MaterialNoveltyApi');

export interface MaterialNoveltyApi {
    getEvaluationData(agent_job_id: string, doc_id: string): Promise<NoveltyEvaluationResponse>;
}
